import $http from "@/services/Http";
import { prefix } from "@/api/config";
import { paginatedResponseToClass, responseToClass } from "@/api/lib";
import Team from "@/models/Team";
import { AxiosPromise } from "axios";
import CreateViewModel from "@/forms/models/organization/team/CreateViewModel";
import PaginationResponse from "@/interfaces/responses/PaginationResponse";

export interface ITeamListOptions {
  page?: number;
  teamName?: string;
  sortBy?: string;
  order?: string;
  archived?: boolean;
  only_user_teams?: boolean;
}
export function list(
  organizationId: string,
  params: ITeamListOptions = {}
): AxiosPromise<PaginationResponse<Team[]>> {
  return $http
    .get(`${prefix}/organizations/${organizationId}/teams`, {
      params: Object.fromEntries(
        Object.entries(params).map(([k, v]) => [
          k,
          typeof v === "boolean" ? +v : v,
        ])
      ),
    })
    .then((response) => paginatedResponseToClass(Team, response));
}

export function show(
  organizationId: string,
  teamId: string
): AxiosPromise<Team> {
  return $http
    .get(`${prefix}/organizations/${organizationId}/teams/${teamId}`)
    .then((response) => responseToClass(Team, response));
}

export function create(
  organizationId: string,
  form: CreateViewModel
): AxiosPromise<Team> {
  return $http
    .post(`${prefix}/organizations/${organizationId}/teams`, form)
    .then((response) => responseToClass(Team, response));
}
